import styled from "styled-components"
import { Colors } from "styles/app-styles"

const ToolbarContainer_s = styled.div`
  align-items: center;
  background: aliceblue;
  border-bottom: 1px solid ${Colors.towerGrey};
  display: flex;
  flex-direction: row;
  height: 35px;
  left: 90px;
  padding: 0 0 0 15px;
  position: fixed;
  width: 100%;
  z-index: 3;
  > div, a {
    align-items: center;
    cursor: pointer;
    display: flex;
    height: 22px;
    margin-right: 8px;
    width: auto;
  }
  svg {
    height: 100%;
    .cls-1, .st0, .r-svg {
      fill: ${Colors.blackPearl};
    }
  }
  a.disabled {
    cursor: not-allowed;
    opacity: 0.55;
  }
`

export default ToolbarContainer_s